
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxPaging,
    DxLookup,
    DxForm,
    DxFilterRow,
    DxSearchPanel,
    DxScrolling,
    DxPager,
    DxValidationRule,

} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DxToast } from 'devextreme-vue/toast';
import 'devextreme-vue/text-area';

import ListadoInformacionService from '../services/listadoinformacion-service';
import ListadoInformacionDetalleService from '../services/grupolistadoinformaciondetalle-service';
import ResponsabilidadEntregaService from '../services/responsabilidadentrega-service';



export default {
    components: {
        DxDataGrid,
        DxColumn,
        DxPaging,
        DxEditing,
        DxLookup,
        DxForm,
        DxItem,
        DxFilterRow,
        DxSearchPanel,
        DxScrolling,
        DxPager,
        DxToast,
        DxValidationRule
    },
    props: {
        supplierId: {
            type: Number,
            default: null,
        },
    },
    data() {

        return {
            dataSourceResponsabilidadEntrega: null,
            procedimientos: null,
            dataSourceServicio: null,
            dataSourceSolicitudServicio: null,
            allowedPageSizes: [5, 10, 20, 50, 'all'],
            showInfo: true,
            showNavButtons: true,
            isVisible: false,
            message: '',
            type: 'info',
           popupOptions: {
                title: 'Listado Información',
                showTitle: true,
                width: 600,
                height: 400,
            },



        };
    },
    created() {

        this.listadoinformaciondetalleService = new ListadoInformacionDetalleService();
        this.listadoinformacionService = new ListadoInformacionService();
        this.responsabilidadentregaService = new ResponsabilidadEntregaService();
    },
    mounted() {

        this.loadDataInfo();
    },
    methods: {
        loadDataInfo() {
            let id = this.supplierId;
            let myJSON = JSON.stringify({
                pid: id
            });
            this.responsabilidadentregaService.getResponsabilidadEntrega().then(data => this.dataSourceResponsabilidadEntrega = data);
            this.listadoinformacionService.getListadoInformacion().then(data => this.dataSourceServicio = data);
            this.listadoinformaciondetalleService.getGrupoListadoInformacionDetalle(myJSON).then(data => this.dataSourceSolicitudServicio = data);
        },
        onSaved() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        onEditCanceled() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        logEvent(eventName) {
            this.events.unshift(eventName);
        },

        deleteRegister(e) {

            let myJSON = JSON.stringify({
                pid: e.data.id,
            });



            this.listadoinformaciondetalleService.deleteGrupoListadoInformacionDetalle(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha eliminado el registro';
                    this.isVisible = true;
                    this.loadDataInfo();
                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;

                }


            });

        },
        editRegister(e) {

            let id = this.supplierId;
            let myJSON = JSON.stringify({
                pid: e.data.id,
                pgrupolistadoinformacionid: id,
                plistadoinformacionid: e.data.listadoinformacionid,
                porden: e.data.orden,
                presponsabilidadentregaid:e.data.responsabilidadentregaid,
            });




            this.listadoinformaciondetalleService.updateGrupoListadoInformacionDetalle(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha actualizado el registro';
                    this.isVisible = true;
                    this.loadDataInfo();
                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;

                }


            });

        },
        createRegister(e) {


            let id = this.supplierId;
            let myJSON = JSON.stringify({

                pgrupolistadoinformacionid: id,
                plistadoinformacionid: e.data.listadoinformacionid,
                porden: e.data.orden,
                presponsabilidadentregaid:e.data.responsabilidadentregaid,
            });


            this.listadoinformaciondetalleService.createGrupoListadoInformacionDetalle(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha creado el registro';
                    this.isVisible = true;
                    this.loadDataInfo();
                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;

                }


            });

        },
        onInitNewRow(e) {
            e.data.bactivo = true;
        },
    },
};
